function waitForOneTrust() {
    hasOneTrustLoaded();
    let attempts = 0;
    const interval = setInterval(function () {
        if (hasOneTrustLoaded() || attempts > 100) {
            clearInterval(interval);
        }
        attempts++;
    }, 100)
}

function hasOneTrustLoaded() {
    if (typeof window.OnetrustActiveGroups === 'string') {
        //check now
        optanonWrapper()
        // and wrap and trigger after cookie opt-in
        window.OptanonWrapper = optanonWrapper;
        return true;

    }
    return false;
}

function sendConsent(trackingConsent) {
    console.log(trackingConsent)
    window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {
        console.log("Shopify Consent Captured")
        //To reload a page once consent is updated by the user
        document.querySelectorAll('.save-preference-btn-handler.onetrust-close-btn-handler, #onetrust-accept-btn-handler, #onetrust-reject-all-handler, #accept-recommended-btn-handler').forEach(el => {
            el.addEventListener('click', function () {
                window.location.reload();
            });
        });
    });
}

function youtubeConsent(iframe) {

    // Get all elements with the specified class
    const consentiframes = document.getElementsByClassName('consent-iframe1');
    // Remove each iframe element
    while (consentiframes.length > 0) {
        consentiframes[0].parentNode.removeChild(consentiframes[0]);
    }

    // Get all elements with the specified class
    var consentElements = document.getElementsByClassName('consent-video-btn');
    // Check if any elements were found
    while (consentElements.length > 0) {
        // Remove the first element with the specified class
        consentElements[0].remove();
    }

    // Get the div elements by their class name
    const consentDivs = document.getElementsByClassName('consent-thumb');
    // Loop through the divs and set their display property to "block"
    for (let i = 0; i < consentDivs.length; i++) {
        consentDivs[i].style.display = 'block';
    }

}

function optanonWrapper() {
    performanceConsent = !!window.OnetrustActiveGroups.includes('C0002');
    functionalConsent = !!window.OnetrustActiveGroups.includes('C0003');
    targetingConsent = !!window.OnetrustActiveGroups.includes('C0004');
    const trackingConsent = { analytics: performanceConsent, marketing: targetingConsent, preferences: functionalConsent, sale_of_data: false };

    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                throw error;
            }
            sendConsent(trackingConsent)
        },
    );
    if (!window.OnetrustActiveGroups.includes('C0002') || !window.OnetrustActiveGroups.includes('C0003') || !window.OnetrustActiveGroups.includes('C0004') || !window.OnetrustActiveGroups.includes('C0005')) {
        let iframes = document.getElementsByTagName("iframe");
        for (var i = 0; i < iframes.length; i++) {
            let src = iframes[i].getAttribute('data-src');
            if (src && src.includes("www.youtube.com")) {
                youtubeConsent(iframes[i]);
            }
        }
    }
}

(function () {
    // Loop through the divs and set their display property to "none"
    // Get the div elements by their class name
    const consentDiv = document.getElementsByClassName('consent-thumb');
    for (let i = 0; i < consentDiv.length; i++) {
        consentDiv[i].style.display = 'none';
    }

    waitForOneTrust();
})();


/**
   * MikMak tracking code
   * This code snippet is responsible for handling various actions and pushing data to the dataLayer object.
   * It defines a callback function, myCallback, which is called when certain actions occur.
   * The myCallback function checks the action type and pushes corresponding data to the dataLayer.
   * The OptanonWrapper function is called on page load and determines whether tracking is allowed based on cookie settings.
   * If tracking is allowed, it sets the widget_callback property of the swnDataLayer object to the myCallback function.
   * If tracking is not allowed, it sets the "do not track" (DNT) flag to true.
   */
var myCallback = function (e) {
    if (e.action === 'buy') {
      dataLayer.push({
        event: 'buy_now',
        retailer: e.retailer.name,
        store: e.store.name,
        product_name: e.product.name,
        product_id: e.product.id,
      });
    } else if (e.action === 'clkloc') {
      dataLayer.push({
        event: 'directions',
        retailer: e.retailer.name,
        store: e.store.name,
      });
    } else if (e.action === 'close') {
      dataLayer.push({
        event: 'widget_close',
      });
    } else if (e.action === 'clk') {
      dataLayer.push({
        event: 'product_selected',
        product_name: e.product.name,
        product_id: e.product.id,
      });
    } else if (e.action === 'clktab') {
      dataLayer.push({
        event: 'online_locale_cta',
        product_name: e.product.name,
        product_id: e.product.id,
      });
    } else if (e.action === 'dploy') {
      dataLayer.push({
        event: 'open_widget',
      });
    } else if (e.action === 'geoloc') {
      dataLayer.push({
        event: 'update_location',
        product_name: e.product.name,
        product_id: e.product.id,
      });
    } else if (e.action === 'clkloc' && e.clklocType === 'tel') {
      dataLayer.push({
        event: 'call_retailer',
        product_name: e.product.name,
        product_id: e.product.id,
      });
    }
  };
  if (!window.swnDataLayer) window.swnDataLayer = {};
  window.swnDataLayer.widget_callback = myCallback;
  window.swnDataLayer.locale = Shopify.locale; // language
  function OptanonWrapper() {
    if (OnetrustActiveGroups.includes('C0002')) {
      !(function (a) {
        (window.swnDataLayer = window.swnDataLayer || {}),
          window.swnDataLayer.setDNT ? swnDataLayer.setDNT(a) : (swnDataLayer.dnt = a);
      })(false);
    } else {
      !(function (a) {
        (window.swnDataLayer = window.swnDataLayer || {}),
          window.swnDataLayer.setDNT ? swnDataLayer.setDNT(a) : (swnDataLayer.dnt = a);
      })(true);
    }
  }
  OptanonWrapper();
